// Browser Push Notification utility for Ameenji CRM

const PERMISSION_KEY = "ameenji_notif_perm_asked";

export function isNotificationSupported() {
  return "Notification" in window;
}

export function getPermissionStatus() {
  if (!isNotificationSupported()) return "unsupported";
  return Notification.permission; // "granted" | "denied" | "default"
}

export async function requestPermission() {
  if (!isNotificationSupported()) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  const result = await Notification.requestPermission();
  localStorage.setItem(PERMISSION_KEY, "true");
  return result;
}

export function hasAskedBefore() {
  return localStorage.getItem(PERMISSION_KEY) === "true";
}

export function showNotification(title, options = {}) {
  if (!isNotificationSupported() || Notification.permission !== "granted") return;
  // Only notify if tab is not focused
  if (document.hasFocus()) return;

  const notif = new Notification(title, {
    icon: "/icon-192.png",
    badge: "/icon-192.png",
    tag: options.tag || "ameenji-crm",
    renotify: true,
    silent: false,
    ...options,
  });

  notif.onclick = () => {
    window.focus();
    if (options.url) {
      window.location.href = options.url;
    }
    notif.close();
  };

  // Auto-close after 6s
  setTimeout(() => notif.close(), 6000);
}

export function notifyNewMessage(senderName, content, isDm = false) {
  const title = isDm ? `${senderName}` : `#${senderName}`;
  const body = isDm ? content : `${content}`;
  showNotification(title, {
    body: body.length > 80 ? body.slice(0, 80) + "..." : body,
    tag: `msg-${Date.now()}`,
    url: "/chat",
  });
}

export function notifyCrmAlert(title, message, url = "/") {
  showNotification(title, {
    body: message.length > 100 ? message.slice(0, 100) + "..." : message,
    tag: `crm-${Date.now()}`,
    url,
  });
}
